import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

let themeColor = localStorage.getItem("refcode") || "-";

export default new Vuetify({
  icons: {
    iconfont: "mdi" || "fa4",
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        default_primary: "#00A562",
        default_primary_dark: "#05906B",
        default_primary_light: "#46B88D",
        default_primary_v2: "#00A562",
        default_primary_v2_dark: "#70CEC1",
        default_primary_v2_light: "#23BBE6",
        default_button_primary: themeColor === "moph" ? "#0f955d" : "#46B88D",
        default_chip_primary: themeColor === "moph" ? "#0f955d" : "#46B88D",
        default_switch_primary: themeColor === "moph" ? "#0f955d" : "#46B88D",
        default_text_primary: themeColor === "moph" ? "#0f955d" : "#46B88D",
        default_background_primary:
          themeColor === "moph" ? "#C8E6C9" : "#D1E6FA",
        background_default: "#FDFDFD",
        chip_primary_light: "#F5FFF8",
        chip_primary_dark: "#EEFBF5",
        chart_color_blue_tone: "#3B82F6",
        chart_color_blue_tone_2: "#2B60E1",
        chart_color_yellow_tone: "#FFCF00",
        chart_color_green_tone: "#00E096",
        chart_color_purple_tone: "#A966FF",
        chart_color_orange_tone: "#FD9E42",
        chart_color_purple_tone_light: "#2B60E1",
        chart_color_orange_tone_light: "#FFC733",
        text_label_chart: "#94A3B8",
        text_highlight_label_chart_blue_tone: "#3C60E5",
        text_highlight_label_chart_orange_tone: "#FD9E42",

        green_status_text: "#007E33",
        green_status: "#D4FFE5",
        red_status_text: "#D1392B",
        red_status: "#FBE5E4",
        yellow_status_text: "#E9A016",
        yellow_status: "#FCF0DA",
        purple_status: "#7052EE",
        grey_status: "#9A9A9A",
        text_title_admin: "#000466",
        text_title_super_admin: "#000466",
        icon_title_admin_background: "#EDF2FF",
        text_detail: "#636363",
        background_card_admin: "#F6F9FF",
        background_menu_admin: "#F8FAFF",

        text_black: "#333333",
        text_sub_black: "#333333",
        text_export: "#4C4C4C",
        background_card_filter: "#FAFAFA",
        background_card_status_note: "#F5F5F5",
        background_card_status_alert: "#F6F9FF",
        background_button_status_alert: "#D2DDF9",
        filter_all_background: "#ECF1FF",
        filter_chip_background: "#D4E1FF",
        filter_chip_background_primary: "#E6F6EF",
        filter_chip_background_v2: "#EEFBF5",
        filter_chip_background_primary_v2: "#03BAA6",
        text_green_v2: "#03BAA6",
        icon_blue: "#2B60E1",
        icon_yellow: "#FFBB33",
        chip_status_yellow: "#FFF8E4",
        chip_status_yellow_text: "#FFC207",
        chip_status_light_blue: "#ECF7FB",
        chip_status_light_blue_text: "#3FB6DC",
        chip_status_green: "#E9F9EF",
        chip_status_green_text: "#2DC76D",
        chip_status_red: "#FFF0ED",
        chip_status_red_text: "#FE7052",
        chip_hide_background: "#F2F2F2",
        text_grey_applicant: "#464646",
        background_blue_tone_2: "#E8EEFF",
        credit_icon: "#FFDE9D",
        credit_icon_text: "#FF8800",
        credit_icon_background: "#FFC733",
        credit_icon_background_2: "#FD9D43",
        background_button_blue_tone: "#F0F5FF",
        sub_title_register: "#989898",
        bg_primary: "#f6fdfc",
        bg_primary_v2: "#03BAA6",
      },
      dark: {},
    },
  },
});
